import styles from "./Limite.module.css";

export const Limite = () => {
  return (
    <fieldset className={styles.fieldsetContainer}>
      <legend className={styles.legend}>
        Como funciona o limite do seguro (LMG)
      </legend>
      <div className={styles.container}>
        <p className={styles.contentTitle}>
          O seguro de Responsabilidade Civil Profissional possui um
          <b> LIMITE MÁXIMO DE GARANTIA</b> único por vigência.
        </p>
        <p className={`${styles.contentSection} ${styles.gradientText}`}>
          Esse limite é dividido conforme o Marco Legal dos Seguros (Lei nº
          15.040/2024):
        </p>
        <div className={styles.divider}>
          <hr />
        </div>
        <div className={styles.percentItemContainer}>
          <div className={`${styles.percentItem} ${styles.gradientText}`}>
            <div className={styles.percentGroup}>
              <span className={styles.percentItemValue}>30</span>
              <span className={styles.percentSymbol}>%</span>
            </div>
            <span className={styles.percentItemLabel}>Custos de defesa</span>
          </div>
          <div className={`${styles.percentItem} ${styles.gradientText}`}>
            <div className={styles.percentGroup}>
              <span className={styles.percentItemValue}>70</span>
              <span className={styles.percentSymbol}>%</span>
            </div>
            <span className={styles.percentItemLabel}>Demais coberturas</span>
          </div>
        </div>
        <div className={styles.divider}>
          <hr />
        </div>
        <p className={styles.contentFotter}>
          <b>Exemplo prático:</b> LMG de R$ 1.000.000 → R$ 300.000 para defesa +
          R$ 700.000 para indenizações.
        </p>
      </div>
    </fieldset>
  );
};
